"use strict";export default class JSPropsUpdaterWeb{addOnJSPropsChangeListener(_animatedComponent){}removeOnJSPropsChangeListener(_animatedComponent){}}